// react and js
import PropTypes from "prop-types";
import { React, useEffect } from "react";
import { useTranslation } from "react-i18next";

// mui
import { CssBaseline } from "@mui/material";
import {
  ThemeProvider as MUIThemeProvider,
  createTheme,
  StyledEngineProvider,
} from "@mui/material/styles";

// components

// hooks

// layouts

// pages

// theme
import typographyStruc from "./typography";

// utils

// widgets

// ----------------------------------------------------------------------
// Code
// ----------------------------------------------------------------------

// ----------------------------------------------------------------------
// Properties
// ----------------------------------------------------------------------

// ----------------------------------------------------------------------
// Main element export(s)
// ----------------------------------------------------------------------
export default function ThemeProvider({ children }) {
  ThemeProvider.propTypes = {
    children: PropTypes.node,
  };

  const { i18n } = useTranslation();

  // Keep <html lang> in sync with the active language. Layout stays LTR
  // for all supported languages (Arabic text renders right-to-left at the
  // text level via the browser's bidi algorithm, but the page layout does
  // not mirror).
  useEffect(() => {
    document.documentElement.setAttribute("lang", i18n.language);
  }, [i18n.language]);

  const theme = createTheme({
    typography: typographyStruc,
    shape: { borderRadius: 10 },
    palette: {
      primary: {
        main: "#000000", // Important for autocomplete preselct
      },
    },
  });

  return (
    <StyledEngineProvider injectFirst>
      <MUIThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </MUIThemeProvider>
    </StyledEngineProvider>
  );
}
